<h1 mat-dialog-title>{{ 'isothermalCharacterizationEdit.dialog.signRerport.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="calibrates-theme" style="overflow-y: hidden;">

    @if (showChangeLangIcon()) {
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'common.reportType.options.language.label' | translate }}</mat-label>
        <mat-select [(ngModel)]="reportConfig.lang" [ngModelOptions]="{standalone: true}">
          @for (item of langs; track item) {
            <mat-option [value]="item.lang">
              <mat-icon svgIcon="{{item.flag}}"></mat-icon>
              {{item.fullLang}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (showReason()) {
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.label' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="reason" name="reason" required [ngModelOptions]="{standalone: true}"></textarea>
        <mat-error>
          {{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.error' | translate }}
        </mat-error>
      </mat-form-field>
    }

    <br /><br />

    <span>{{ 'common.reportType.options.dataTable' | translate }}:</span>
    <br />
    <mat-radio-group class="vertical-radio-group" [(ngModel)]="reportConfig.dataTableInclude"
      [ngModelOptions]="{standalone: true}">
      @for (item of reportConfig.dataTypes; track item) {
        <mat-radio-button class="vertical-radio-button" [value]="item">
          {{ 'common.reportType.options.' + item | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>

  <br /><br />

  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.sign' | translate
    }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>